module.exports = __webpack_public_path__ + "static/media/shazam.cec4b3fc.svg";